var map = {
	"./current/back.jpg": 150,
	"./current/missing-new.jpg": 151,
	"./current/missing.jpg": 152,
	"./montaneranch/back.jpg": 150,
	"./montaneranch/missing-new.jpg": 151,
	"./montaneranch/missing.jpg": 152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 149;